import React from 'react'
import { Button, Col, Grid, Icon, Spinner } from '../../../components'
import PropTypes from 'prop-types'
import styles from '../datedlist.module.scss'

const More = ({
  loading = false,
  handleGetMoreItems = () => {},
  text = '',
}) => (
  <Grid justifyContent="center">
    <Col sm="auto" xs="auto">
      {loading ? (
        <Spinner
          className={styles['dated--list__spinner']}
          color="basic-primary-blue"
        />
      ) : (
        <Button
          className={styles['dated--list__more-button']}
          onClick={handleGetMoreItems}
          rounded
          size="l"
          variant="link"
          endIcon={<Icon color="inherit" size={'m'} name="arrow1-down" />}
        >
          {text}
        </Button>
      )}
    </Col>
  </Grid>
)

export default More

More.propTypes = {
  loading: PropTypes.bool,
  handleGetMoreItems: PropTypes.func,
  text: PropTypes.string,
}
